import { useLocation, useParams, useSearchParams } from "react-router-dom";
import {
  useGetMappedUnmappedProducts,
  useGetMarketPlaceLumiProducts,
  useGetMarketPlaceProducts,
  useGetMarketPlaceStores,
} from "../../../../../hooks/api/queries/useMarketPlace";
import { useContext, useEffect, useState } from "react";
import { ToastContext } from "../../../../../hooks/context";
import {
  marketPlaceProductsMapping,
  marketPlaceStoresMapping,
  marketPlaceUpdateProductsMapping,
} from "../../../../../services/marketplace";
import { useMutation } from "react-query";

export const useConnectStore = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const triggerToast = useContext(ToastContext);
  const [search, setSearch] = useSearchParams();
  const [successModal, setSuccessModal] = useState(false);

  const connection_id = search.get("id") || id;
  const mapping_id = search.get("mapping_id");
  const store_id = search.get("store_id");
  const queryText = search.get("query");

  const { data: marketPlaceStores } = useGetMarketPlaceStores({
    queries: `?connection_id=${connection_id}`,
    isEnabled: connection_id ? true : false,
  });

  const { data: marketPlaceProducts, isLoading: isLoadingMarketPlaceProducts } =
    useGetMarketPlaceProducts({
      queries:
        queryText && queryText.length > 0
          ? `?connection_id=${connection_id}&store_mapping_id=${mapping_id}&query=${queryText}`
          : `?connection_id=${connection_id}&store_mapping_id=${mapping_id}`,
      isEnabled: connection_id && mapping_id ? true : false,
    });

  const { data: marketPlaceLumiProducts } = useGetMarketPlaceLumiProducts({
    queries: `?connection_id=${connection_id}&lumi_store_id=${store_id}`,
    isEnabled: connection_id && store_id ? true : false,
  });

  const {
    data: mappedUnmappedProducts,
    isLoading: isLoadingMappedUnmappedProducts,
  } = useGetMappedUnmappedProducts({
    queries:
      queryText && queryText.length > 0
        ? `?connection_id=${connection_id}&store_mapping_id=${mapping_id}&query=${queryText}`
        : `?connection_id=${connection_id}&store_mapping_id=${mapping_id}`,
    isEnabled:
      connection_id && mapping_id && pathname.includes("edit") ? true : false,
  });

  const storesMapping = useMutation({
    mutationFn: (data) =>
      marketPlaceStoresMapping({
        data,
        queries: `?connection_id=${connection_id}`,
      }),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
    },
  });

  const productsMapping = useMutation({
    mutationFn: (data) =>
      marketPlaceProductsMapping({
        data,
        queries: `?connection_id=${connection_id}`,
      }),
    onSuccess: (data) => {
      triggerToast(data.data.detail, "success");
      setSuccessModal(true);
    },
  });

  const updateProductsMapping = useMutation({
    mutationFn: (data) =>
      marketPlaceUpdateProductsMapping({
        data,
        queries: `?connection_id=${connection_id}`,
      }),
    onSuccess: () => {
      triggerToast("Product Mapping updated successfully", "success");
      setSuccessModal(true);
    },
  });

  const searchConncections = (value) => {
    if (value.length === 0) search.delete("query");
    else search.set("query", value);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  useEffect(() => {
    if (storesMapping.data) {
      search.set("mapping_id", storesMapping.data?.data?.data?.id);
      search.set("store_id", storesMapping.data?.data?.data?.lumi_store?.id);
      setSearch(search, { replace: true });
    }
  }, [storesMapping.data]);

  return {
    search,
    mapping_id,
    marketPlaceStores,
    storesMapping,
    productsMapping,
    updateProductsMapping,
    isLoadingMarketPlaceProducts,
    marketPlaceProducts,
    marketPlaceLumiProducts,
    isLoadingMappedUnmappedProducts,
    mappedUnmappedProducts,
    triggerToast,
    searchConncections,
    successModal,
    setSuccessModal,
  };
};
